import {
    Service,
    AvailabilityBlockStates,
    AvailabilityBlockOrdering,
    AvailabilityBlock,
} from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { DateTimeService, LocalizedProperty, useAppClockService, useTimezone } from '@mews/framework';
import { TableState } from '@optimus-web/core';
import { addYearsUtc } from '@mews-commander/utils';
import { AvailabilityBlockReportFilterValues } from './types';
import { FilterValueKey } from './constants';

export const mapServiceToOption = (s: Service) =>
    createOption({ value: s.id, label: <LocalizedProperty property={s.names} /> });

export const useDefaultFilterValues = ({ serviceId }: { serviceId: string | null }) => {
    const appClockService = useAppClockService();
    const timezone = useTimezone();

    const today = appClockService.getAppNowUtc().value;
    const todayPlusOneYear = addYearsUtc({ utc: today, timezone, yearCount: 1 });

    const defaultValues: AvailabilityBlockReportFilterValues = {
        [FilterValueKey.startDate]: today,
        [FilterValueKey.endDate]: todayPlusOneYear,
        [FilterValueKey.serviceId]: serviceId,
        [FilterValueKey.states]: Object.values(AvailabilityBlockStates).filter(
            (s) => s !== AvailabilityBlockStates.Canceled
        ),
        [FilterValueKey.companyId]: null,
        [FilterValueKey.travelAgencyId]: null,
    };

    return defaultValues;
};

export const prepareQueryParameters = (
    filterValues: AvailabilityBlockReportFilterValues,
    tableState: TableState<AvailabilityBlock>,
    timezone: string
) => {
    const { startDate, endDate, ...restFilters } = filterValues;
    const sortFilters = Object.entries(tableState.sort)?.[0];
    const orderBy = sortFilters?.[0] === 'endUtc' ? AvailabilityBlockOrdering.End : AvailabilityBlockOrdering.Start;
    const order = sortFilters?.[1].order;

    return {
        reportIntervalLocal: {
            start: DateTimeService.fromUtcString(startDate, timezone).value,
            end: DateTimeService.fromUtcString(endDate, timezone).value,
        },
        availabilityBlockReportFilters: { ...restFilters, orderBy, order },
    };
};
